import { render, staticRenderFns } from "./InactiveAccounts.vue?vue&type=template&id=996b26ce"
import script from "./InactiveAccounts.vue?vue&type=script&lang=js"
export * from "./InactiveAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports